import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarClientesExcel`, method: 'POST', body: value, token: token})
}
